import React, { useEffect, useState } from 'react'
import NavTabs from '~components/NavTabs'
import useFilterPesquisas from '../hooks/useFilterPesquisas';
import { useConfigureFooter } from '~hooks/useHelpers';
import CardItem from '../Components/Cards/CardItem';
import { useParams } from 'react-router-dom';
import ListSearchs from '../Components/Cards/ListSearchs';
import usePesquisasCampoClientes from '~fetchs/usePesquisasCampoClientes';
import ModalResponse from '~components/Modal/ModalResponse';
import useModalAction from '~components/Modal/hooks/useModalAction';
import useCliente from '~fetchs/useCliente';
import ClientHeader from '~components/ClientInfo/ClientHeader';

const ViewForm = () => {

  const { parameter: idCliente } = useParams();

  const { cliente } = useCliente(idCliente);
  
  const [filters, setFilters] = useState({ searchText: "", status: "Todos", title: 0, validityPeriod: "Todos" });
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(5);
  const [loading, setLoading] = useState(false);

  const [showMessageModal, setShowMessageModal] = useState({
    text: "",
    type: "success",
  });

  const { isModalOpenAction: isModalResponse, closeModalAction: closeModalResponse, openModalAction: openModalResponse } = useModalAction();

  const { pesquisasCampoCliente, pesquisasCampoClienteAll, carregando } = usePesquisasCampoClientes({ filters, clienteId: parseInt(idCliente), tipo: "ativos" });

  return (
    <>
      <ClientHeader dados={cliente} />

       <NavTabs
        navs={[
          { name: "Formulários Ativos", link: `/gestao-de-pesquisa/formularios/${idCliente}` },
          { name: "Histórico de Formulários", link: `/gestao-de-pesquisa/historico-formularios/${idCliente}` }
        ]}
      />
      <ListSearchs setShowMessageModal={setShowMessageModal} pesquisas={(pesquisasCampoCliente || [])} pesquisasAll={pesquisasCampoClienteAll} skip={skip} take={take} setSkip={setSkip} carregando={carregando} setLoading={setLoading} loading={loading} tipo={"ativos"} />

      {showMessageModal.text ? (
        <ModalResponse
          isOpen={true}
          closeModal={() => {
            const onClose = showMessageModal.onClose;
            setShowMessageModal((prev) => ({
              ...prev,
              text: "",
              onClose: () => {}
            }));

            closeModalResponse();

            if(onClose && typeof onClose == "function")
              onClose();
          }}
          status={showMessageModal.type ?? ""}
          message={showMessageModal.text ?? ""}
          submessage={showMessageModal.submessage ?? ""}
          button="Ok"
        />
      ) : null}
    </>
  )
}

export default ViewForm